var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.013784, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.569905, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.706111, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.788861, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.601072, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.994589, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(565.130785, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.245186, 298.881905)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.894787, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.450908, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.587114, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.669864, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.482075, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.875592, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(565.011788, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.126189, 298.754288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.77579, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.331912, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.468117, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.550867, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.363078, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.756595, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.892791, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4fab",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.007192, 298.626684)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.761793, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.317914, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.45412, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.53687, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.349081, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.742598, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.878794, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(646.993195, 295.037393)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.642794, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.198915, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.335121, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.417871, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.230082, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.623599, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.759795, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#643db8",
    fillOpacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(646.874196, 294.909776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.523797, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.847656 L 0 0.140625 L 72.164062 0.140625 L 72.164062 -31.265625 L 60.4375 -45.921875 L 72.582031 -55.832031 L 72.582031 -97.847656 Z M 24.007812 -73.558594 L 48.15625 -73.558594 L 48.15625 -55.832031 L 24.007812 -55.832031 Z M 48.15625 -24.566406 L 24.007812 -24.566406 L 24.007812 -53.738281 Z M 48.15625 -24.566406 "
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.079918, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.216124, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.298874, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -97.707031 L 0 -97.707031 L 0 0 L 24.425781 0 L 24.425781 -27.917969 L 48.992188 -51.925781 L 48.992188 0 L 73.417969 0 L 73.417969 -97.707031 L 48.992188 -97.707031 L 48.992188 -55.414062 L 24.425781 -55.414062 Z M 24.425781 -97.707031 "
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.111085, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -97.984375 L 0 -0.140625 L 24.425781 -0.140625 L 24.425781 -47.179688 L 48.851562 -24.285156 L 48.851562 -0.140625 L 73.558594 -0.140625 L 73.558594 -97.984375 Z M 24.425781 -48.851562 L 24.425781 -73.417969 L 48.851562 -73.417969 L 48.851562 -48.851562 Z M 24.425781 -48.851562 "
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.504602, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.023438 -97.707031 L -0.140625 -97.707031 L -0.140625 0 L 66.023438 0 L 66.023438 -24.148438 L 24.285156 -24.148438 L 24.285156 -73.558594 L 66.023438 -73.558594 Z M 66.023438 -97.707031 "
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.640798, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.425781 -40.757812 L 24.425781 -97.847656 L 0 -97.847656 L 0 0 L 24.425781 0 L 24.425781 -38.664062 L 48.433594 -38.664062 L 48.433594 0 L 72.859375 0 L 72.859375 -38.664062 L 60.578125 -48.714844 L 72.304688 -62.949219 L 72.304688 -97.847656 L 48.433594 -97.847656 L 48.433594 -69.789062 Z M 24.425781 -40.757812 "
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbad8",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(646.755199, 294.782173)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.675781 -97.984375 L -0.140625 -97.984375 L -0.140625 -66.441406 L 23.589844 -41.734375 L 24.285156 -41.734375 L 24.285156 -73.417969 L 74.675781 -73.417969 Z M 49.96875 -24.566406 L -0.140625 -24.566406 L -0.140625 0 L 74.675781 0 L 74.675781 -35.734375 L 51.226562 -54.996094 L 49.96875 -54.996094 Z M 49.96875 -24.566406 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.f7f274b07347b482db0735a71e78cc7c.svg";
export { ForwardRef as ReactComponent };